import React from 'react';

import Icon from "@/components/elements/icons/Icons"
import { IconLibrary } from "@/interfaces/IconLibrary"

interface IViewPermissionHoverListItem {
    title:string,
    subTitle?:string,
    isEditor?: boolean,
    adminPermissions?: boolean,
    icon?: IconLibrary, id?:number
    onFocus?: () => void
    onBlur?:() => void
}


function ViewPermissionHoverListItem({title, subTitle, isEditor, adminPermissions, icon=IconLibrary.USERS, id, onFocus, onBlur} : IViewPermissionHoverListItem){
    
    const LinkContent = <>
        <div className='icon-wrapper'>
            <Icon iconName={icon} sizeInPx='12' />
        </div>    
        <div className='information-wrapper'>
            <p className='title'>{title}</p>
            {subTitle && <p className='subtitle'>{subTitle}</p>}    
        </div>
    </>
    
    
    return (
        adminPermissions 
        ? <a 
            href={adminPermissions ? `${window.location.origin}/admin/OrganizationUserGroup/UserGroupDetail/${id}` : ''}
            target={'_blank'}
            className={`view-permissions-hover-list-item ${isEditor?'editor': ''} is-admin`}
            aria-label={`view ${title} - opens in new tab`}
            onFocus={onFocus}
            onBlur={onBlur}
        >
            {LinkContent}
        </a>
        : <div className={`view-permissions-hover-list-item ${isEditor?'editor': ''}`}>
            {LinkContent}
        </div>
        
    )
}

export default  ViewPermissionHoverListItem